// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #f5f5f5 !important;
  overflow: hidden !important;
  max-width: 100vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
}

.responsive-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.responsive-filter-item {
  flex: 1 1 180px;
  min-width: 0;
}

.responsive-filter-bar > .ui.input,
.responsive-filter-bar > .ui.dropdown,
.responsive-filter-bar > input,
.responsive-filter-bar > div {
  flex: 1 1 180px;
  min-width: 0;
}

.responsive-filter-item--compact {
  flex-basis: 140px;
}

.responsive-filter-item > .ui.input,
.responsive-filter-item > .ui.dropdown,
.responsive-filter-item > input,
.responsive-filter-item .ui.input,
.responsive-filter-item .ui.dropdown {
  width: 100%;
  min-width: 0 !important;
}

.responsive-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.responsive-table-wrapper > .ui.table {
  min-width: 860px;
}

.responsive-pagination-cell {
  white-space: normal !important;
}

.dashboard-filter-row {
  row-gap: 12px;
}

.dashboard-filter-action {
  display: flex !important;
  align-items: flex-end !important;
}

.dashboard-filter-action .ui.button {
  min-height: 38px;
}

.souscription-form-layout {
  display: block !important;
}

.subscription-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.subscription-toolbar-title {
  flex: 1 1 260px;
}

.subscription-toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.subscription-pagination-wrap {
  display: flex;
  justify-content: center;
}

.subscription-submit-actions {
  margin-top: 16px;
}

.text.center {
  text-align: center !important;
}

.field-error {
  color: rgb(136, 29, 29);
}

.input.search input {
  border-radius: 25px !important;
}

.column .ui.list .item .header {
  margin-bottom: 10px;
}

#souscription-info-encaissement .item .header {
  margin-bottom: 8px;
}

.sticky-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 1;
  border-top: 2px solid #ccc;
}

@media only screen and (max-width: 767px) {
  html {
    overflow-y: auto !important;
    overscroll-behavior-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  body {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    height: auto !important;
    max-height: none !important;
    overscroll-behavior-y: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  body::-webkit-scrollbar {
    display: none;
  }

  .page-content .ui.table {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .page-content .ui.table thead,
  .page-content .ui.table tbody,
  .page-content .ui.table tr {
    white-space: nowrap;
  }

  .page-content .ui.pagination.menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .responsive-filter-bar {
    gap: 10px;
  }

  .responsive-filter-item,
  .responsive-filter-item--compact,
  .responsive-filter-bar > .ui.input,
  .responsive-filter-bar > .ui.dropdown,
  .responsive-filter-bar > input,
  .responsive-filter-bar > div {
    flex: 1 1 100%;
  }

  .responsive-table-wrapper {
    margin-left: -2px;
    margin-right: -2px;
  }

  .responsive-pagination-cell {
    text-align: center !important;
  }

  .dashboard-filter-action .ui.button {
    width: 100%;
  }

  .subscription-toolbar,
  .subscription-toolbar-actions {
    align-items: stretch;
  }

  .subscription-toolbar-title {
    flex-basis: 100%;
  }

  .subscription-toolbar-actions {
    width: 100%;
    justify-content: stretch;
  }

  .subscription-toolbar-actions > * {
    flex: 1 1 100%;
    min-width: 0;
  }

  .subscription-toolbar-actions .ui.button,
  .subscription-toolbar-actions .ui.pagination.menu,
  .subscription-pagination-wrap {
    width: 100%;
  }

  .subscription-toolbar-actions .ui.pagination.menu {
    justify-content: center;
  }

  .subscription-submit-actions .ui.button {
    width: 100%;
  }

  .subscription-tab-panel .ui.tabular.menu {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .subscription-tab-panel .ui.tabular.menu .item {
    white-space: normal;
    flex: 0 0 auto;
    overflow: visible;
    text-overflow: unset;
  }

  .subscription-mono-tab-panel .ui.vertical.tabular.menu,
  .subscription-mono-tab-panel .ui.tabular.menu {
    flex-direction: row;
    align-items: stretch;
    width: 100%;
  }

  .subscription-mono-tab-panel .ui.vertical.tabular.menu .item,
  .subscription-mono-tab-panel .ui.tabular.menu .item {
    flex: 0 0 152px;
    min-width: 152px;
    max-width: 180px;
    min-height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.25;
    overflow-wrap: anywhere;
    word-break: normal;
    padding: 10px 12px !important;
  }

  .subscription-flotte-tab-panel .ui.vertical.tabular.menu,
  .subscription-flotte-tab-panel .ui.tabular.menu {
    flex-direction: row;
    align-items: stretch;
    width: 100%;
  }

  .subscription-flotte-tab-panel .ui.vertical.tabular.menu .item,
  .subscription-flotte-tab-panel .ui.tabular.menu .item {
    flex: 0 0 168px;
    min-width: 168px;
    max-width: 210px;
    min-height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.25;
    overflow-wrap: anywhere;
    word-break: normal;
    padding: 10px 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/app.scss","webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;ACCF;;ADGE;EACE,aAAA;ECAJ,eAAA;EACE,SAAS;EDGX,qBAAA;ACDA;;AAEA;EDIE,eAAA;EACE,YAAA;ACFJ;;ADeM;;;;EASF,eAAA;EACE,YAAA;ACjBN;;ADuBA;EACE,iBAAA;ACpBF;;AAEA;;;;;ED0BE,WAAA;EACA,uBAAA;ACpBF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,mBAAmB;IACnB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;;IAEE,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;;IAEE,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;EAC/B;AACF","sourcesContent":["body {\n  background: #f5f5f5 !important;\n  overflow: hidden !important;\n  max-width: 100vw !important;\n  height: 100vh !important;\n  max-height: 100vh !important;\n}\n\n.responsive-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.responsive-filter-item {\n  flex: 1 1 180px;\n  min-width: 0;\n}\n\n.responsive-filter-bar > .ui.input,\n.responsive-filter-bar > .ui.dropdown,\n.responsive-filter-bar > input,\n.responsive-filter-bar > div {\n  flex: 1 1 180px;\n  min-width: 0;\n}\n\n.responsive-filter-item--compact {\n  flex-basis: 140px;\n}\n\n.responsive-filter-item > .ui.input,\n.responsive-filter-item > .ui.dropdown,\n.responsive-filter-item > input,\n.responsive-filter-item .ui.input,\n.responsive-filter-item .ui.dropdown {\n  width: 100%;\n  min-width: 0 !important;\n}\n\n.responsive-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.responsive-table-wrapper > .ui.table {\n  min-width: 860px;\n}\n\n.responsive-pagination-cell {\n  white-space: normal !important;\n}\n\n.dashboard-filter-row {\n  row-gap: 12px;\n}\n\n.dashboard-filter-action {\n  display: flex !important;\n  align-items: flex-end !important;\n}\n\n.dashboard-filter-action .ui.button {\n  min-height: 38px;\n}\n\n.souscription-form-layout {\n  display: block !important;\n}\n\n.subscription-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.subscription-toolbar-title {\n  flex: 1 1 260px;\n}\n\n.subscription-toolbar-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.subscription-pagination-wrap {\n  display: flex;\n  justify-content: center;\n}\n\n.subscription-submit-actions {\n  margin-top: 16px;\n}\n\n.text {\n  &.center {\n    text-align: center !important;\n  }\n}\n\n.field-error {\n  color: rgb(136, 29, 29);\n}\n\n.input.search {\n  input {\n    border-radius: 25px !important;\n  }\n}\n\n.ui.progress {\n  .bar {\n    .progress {}\n  }\n}\n\n.column {\n  .ui.list {\n    .item {\n      .header {\n        margin-bottom: 10px;\n      }\n    }\n  }\n}\n\n#souscription-info-encaissement {\n  .item {\n    .header {\n      margin-bottom: 8px;\n    }\n  }\n}\n\n\n.sticky-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n}\n\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  background: white;\n  z-index: 1;\n  border-top: 2px solid #ccc;\n}\n\n@media only screen and (max-width: 767px) {\n  html {\n    overflow-y: auto !important;\n    overscroll-behavior-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  body {\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    height: auto !important;\n    max-height: none !important;\n    overscroll-behavior-y: auto;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  body::-webkit-scrollbar {\n    display: none;\n  }\n\n  .page-content .ui.table {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .page-content .ui.table thead,\n  .page-content .ui.table tbody,\n  .page-content .ui.table tr {\n    white-space: nowrap;\n  }\n\n  .page-content .ui.pagination.menu {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .responsive-filter-bar {\n    gap: 10px;\n  }\n\n  .responsive-filter-item,\n  .responsive-filter-item--compact,\n  .responsive-filter-bar > .ui.input,\n  .responsive-filter-bar > .ui.dropdown,\n  .responsive-filter-bar > input,\n  .responsive-filter-bar > div {\n    flex: 1 1 100%;\n  }\n\n  .responsive-table-wrapper {\n    margin-left: -2px;\n    margin-right: -2px;\n  }\n\n  .responsive-pagination-cell {\n    text-align: center !important;\n  }\n\n  .dashboard-filter-action .ui.button {\n    width: 100%;\n  }\n\n  .subscription-toolbar,\n  .subscription-toolbar-actions {\n    align-items: stretch;\n  }\n\n  .subscription-toolbar-title {\n    flex-basis: 100%;\n  }\n\n  .subscription-toolbar-actions {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .subscription-toolbar-actions > * {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .subscription-toolbar-actions .ui.button,\n  .subscription-toolbar-actions .ui.pagination.menu,\n  .subscription-pagination-wrap {\n    width: 100%;\n  }\n\n  .subscription-toolbar-actions .ui.pagination.menu {\n    justify-content: center;\n  }\n\n  .subscription-submit-actions .ui.button {\n    width: 100%;\n  }\n\n  .subscription-tab-panel .ui.tabular.menu {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .subscription-tab-panel .ui.tabular.menu .item {\n    white-space: normal;\n    flex: 0 0 auto;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .subscription-mono-tab-panel .ui.vertical.tabular.menu,\n  .subscription-mono-tab-panel .ui.tabular.menu {\n    flex-direction: row;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .subscription-mono-tab-panel .ui.vertical.tabular.menu .item,\n  .subscription-mono-tab-panel .ui.tabular.menu .item {\n    flex: 0 0 152px;\n    min-width: 152px;\n    max-width: 180px;\n    min-height: 68px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n    word-break: normal;\n    padding: 10px 12px !important;\n  }\n\n  .subscription-flotte-tab-panel .ui.vertical.tabular.menu,\n  .subscription-flotte-tab-panel .ui.tabular.menu {\n    flex-direction: row;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .subscription-flotte-tab-panel .ui.vertical.tabular.menu .item,\n  .subscription-flotte-tab-panel .ui.tabular.menu .item {\n    flex: 0 0 168px;\n    min-width: 168px;\n    max-width: 210px;\n    min-height: 72px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n    word-break: normal;\n    padding: 10px 12px !important;\n  }\n}\n","body {\n  background: #f5f5f5 !important;\n  overflow: hidden !important;\n  max-width: 100vw !important;\n  height: 100vh !important;\n  max-height: 100vh !important;\n}\n\n.responsive-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.responsive-filter-item {\n  flex: 1 1 180px;\n  min-width: 0;\n}\n\n.responsive-filter-bar > .ui.input,\n.responsive-filter-bar > .ui.dropdown,\n.responsive-filter-bar > input,\n.responsive-filter-bar > div {\n  flex: 1 1 180px;\n  min-width: 0;\n}\n\n.responsive-filter-item--compact {\n  flex-basis: 140px;\n}\n\n.responsive-filter-item > .ui.input,\n.responsive-filter-item > .ui.dropdown,\n.responsive-filter-item > input,\n.responsive-filter-item .ui.input,\n.responsive-filter-item .ui.dropdown {\n  width: 100%;\n  min-width: 0 !important;\n}\n\n.responsive-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.responsive-table-wrapper > .ui.table {\n  min-width: 860px;\n}\n\n.responsive-pagination-cell {\n  white-space: normal !important;\n}\n\n.dashboard-filter-row {\n  row-gap: 12px;\n}\n\n.dashboard-filter-action {\n  display: flex !important;\n  align-items: flex-end !important;\n}\n\n.dashboard-filter-action .ui.button {\n  min-height: 38px;\n}\n\n.souscription-form-layout {\n  display: block !important;\n}\n\n.subscription-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.subscription-toolbar-title {\n  flex: 1 1 260px;\n}\n\n.subscription-toolbar-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.subscription-pagination-wrap {\n  display: flex;\n  justify-content: center;\n}\n\n.subscription-submit-actions {\n  margin-top: 16px;\n}\n\n.text.center {\n  text-align: center !important;\n}\n\n.field-error {\n  color: rgb(136, 29, 29);\n}\n\n.input.search input {\n  border-radius: 25px !important;\n}\n\n.column .ui.list .item .header {\n  margin-bottom: 10px;\n}\n\n#souscription-info-encaissement .item .header {\n  margin-bottom: 8px;\n}\n\n.sticky-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n}\n\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  background: white;\n  z-index: 1;\n  border-top: 2px solid #ccc;\n}\n\n@media only screen and (max-width: 767px) {\n  html {\n    overflow-y: auto !important;\n    overscroll-behavior-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  body {\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    height: auto !important;\n    max-height: none !important;\n    overscroll-behavior-y: auto;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  body::-webkit-scrollbar {\n    display: none;\n  }\n\n  .page-content .ui.table {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .page-content .ui.table thead,\n  .page-content .ui.table tbody,\n  .page-content .ui.table tr {\n    white-space: nowrap;\n  }\n\n  .page-content .ui.pagination.menu {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .responsive-filter-bar {\n    gap: 10px;\n  }\n\n  .responsive-filter-item,\n  .responsive-filter-item--compact,\n  .responsive-filter-bar > .ui.input,\n  .responsive-filter-bar > .ui.dropdown,\n  .responsive-filter-bar > input,\n  .responsive-filter-bar > div {\n    flex: 1 1 100%;\n  }\n\n  .responsive-table-wrapper {\n    margin-left: -2px;\n    margin-right: -2px;\n  }\n\n  .responsive-pagination-cell {\n    text-align: center !important;\n  }\n\n  .dashboard-filter-action .ui.button {\n    width: 100%;\n  }\n\n  .subscription-toolbar,\n  .subscription-toolbar-actions {\n    align-items: stretch;\n  }\n\n  .subscription-toolbar-title {\n    flex-basis: 100%;\n  }\n\n  .subscription-toolbar-actions {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .subscription-toolbar-actions > * {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .subscription-toolbar-actions .ui.button,\n  .subscription-toolbar-actions .ui.pagination.menu,\n  .subscription-pagination-wrap {\n    width: 100%;\n  }\n\n  .subscription-toolbar-actions .ui.pagination.menu {\n    justify-content: center;\n  }\n\n  .subscription-submit-actions .ui.button {\n    width: 100%;\n  }\n\n  .subscription-tab-panel .ui.tabular.menu {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .subscription-tab-panel .ui.tabular.menu .item {\n    white-space: normal;\n    flex: 0 0 auto;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .subscription-mono-tab-panel .ui.vertical.tabular.menu,\n  .subscription-mono-tab-panel .ui.tabular.menu {\n    flex-direction: row;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .subscription-mono-tab-panel .ui.vertical.tabular.menu .item,\n  .subscription-mono-tab-panel .ui.tabular.menu .item {\n    flex: 0 0 152px;\n    min-width: 152px;\n    max-width: 180px;\n    min-height: 68px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n    word-break: normal;\n    padding: 10px 12px !important;\n  }\n\n  .subscription-flotte-tab-panel .ui.vertical.tabular.menu,\n  .subscription-flotte-tab-panel .ui.tabular.menu {\n    flex-direction: row;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .subscription-flotte-tab-panel .ui.vertical.tabular.menu .item,\n  .subscription-flotte-tab-panel .ui.tabular.menu .item {\n    flex: 0 0 168px;\n    min-width: 168px;\n    max-width: 210px;\n    min-height: 72px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n    word-break: normal;\n    padding: 10px 12px !important;\n  }\n}/*# sourceMappingURL=app.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
